/**
 * The words on a roster row and its buttons (ORDR-120, FR-STF-004, 010).
 *
 * THE HOLDER IS A PERSON, NOT AN ID PREFIX. ORDR-104 settled for eight
 * characters of `user_id` because the grants read carried no holder; the
 * roster read does. An id prefix survives only for a holder whose user row is
 * missing, and says plainly that the person is unknown.
 *
 * THE BUTTON NAMES WHAT IT DOES. "Revoke" beside two identical-looking rows was
 * a coin flip (ORDR-104). A button reading "Revoke Sam Cook's Kitchen Display
 * access" is the confirmation, which is why there is no dialog: one click, and
 * the click already said who and what.
 */

import type { CatalogRole, RosterEntry } from "./types.js";

/** `display_name`, else `email`, else a marked id prefix; your own row says "You". */
export function holderName(entry: RosterEntry, ownUserId: string): string {
  const { holder } = entry;
  const name =
    holder === null
      ? `Unknown person (${entry.grant.user_id.slice(0, 8)})`
      : (holder.display_name ?? holder.email);
  return entry.grant.user_id === ownUserId ? `You (${name})` : name;
}

/** The catalogue's name for a role, else its key (a pruned role has no name). */
export function roleName(roleKey: string, catalog: readonly CatalogRole[]): string {
  return catalog.find((role) => role.key === roleKey)?.name ?? roleKey;
}

/** "Revoke Sam Cook's Kitchen Display access", or "Revoke your ... access". */
export function actionLabel(
  verb: "Revoke" | "Restore",
  holder: string,
  role: string,
  own: boolean,
): string {
  return own ? `${verb} your ${role} access` : `${verb} ${holder}'s ${role} access`;
}
